import { render } from "./TextAreaInput.vue?vue&type=template&id=987d93b0&ts=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__